import styled from 'styled-components';
import { detailsBackground, primaryColorLight } from '../../../config/colors';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 30px; // to make sure the bottom dropdown expanded menu is visible

  .table-module {
    width: 100%;
    border-spacing: 0;
    font-size: 14px;

    .thead-module .th-module,
    .tfoot-module .td-module {
      background-color: ${primaryColorLight};
      height: 45px;
    }

    .thead-module .th-module,
    .tbody-module .td-module,
    .tfoot-module .td-module {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 2px solid white;
      border-right: 2px solid white;
      text-align: center;
      :first-child {
        border-left: 2px solid white;
      }
    }
    .tbody-module .td-module {
      height: 4rem;
      :first-of-type {
        width: 2.5rem;
        background-color: ${detailsBackground};
        border: 0;
      }
      :nth-of-type(7),
      :nth-of-type(8) {
        padding: 0;
      }
      :last-of-type {
        padding: 0;
        svg {
          transition: transform 0.2s linear;
        }
      }
    }
    .td-module-invisible {
      visibility:none;
    }
    .tfoot-module {
      .tr-module .td-module:first-child {
        opacity: 0;
      }
    }
  }
  .td-expanded-module {
    padding-left: 2.5rem !important;
    border-left: 0 !important;
    border-right: 0 !important;
  }
`;
